export const CARRIER_RECOMMENDATION_RESPONSE = "CARRIER_RECOMMENDATION_RESPONSE"
export const MULTIPLE_CARRIER_RECOMMENDATION_RESPONSE = "MULTIPLE_CARRIER_RECOMMENDATION_RESPONSE"

export type CarrierRecommendationResponse = {
    type: typeof CARRIER_RECOMMENDATION_RESPONSE;
    data: CarrierRecommendationModel;
};

export type CarrierRecommendationModel = {
    carrier: string,
    businessClass: string,
    carrierBusinessClass: string,
    notices: Notices[]
}

export type MultipleCarrierRecommendationResponse = {
    type: typeof MULTIPLE_CARRIER_RECOMMENDATION_RESPONSE;
    data: RecommendedCarrier[];
    notices: Notices[];
};

export type RecommendedCarrier = {
    carrier: string;
    label: string;
    businessClass: string;
    active: boolean;
    order: number;
    imageUrl: string;
    redirectUrl: string;   
    isBoldPenguinOverride: boolean;
    carrierBusinessClass: string;
}

export type Notices = {
    noticeType: string;
    messageCode: string;
    message: string;
    severity: string;
}


export const InitCarrierRecommendationModel = (): CarrierRecommendationModel => {
    return {
        carrier: "",
        businessClass: "",
        carrierBusinessClass: "",
        notices: []
    };
}

export const InitMultipleCarrierRecommendationModel = (): RecommendedCarrier[] => {
    return [];
}